import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { clearAllEnrolmentCodes } from "../../utils/sessionCleanup";

const TopNavbar = ({ onToggleSidebar, title = "Business Management" }) => {
  const { user, logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    clearAllEnrolmentCodes();
    setDropdownOpen(false);
    logout();
  };

  // Get user initials for avatar
  const getUserInitials = () => {
    if (!user?.name) return "U";
    const names = user.name.split(" ");
    if (names.length >= 2) {
      return `${names[0][0]}${names[1][0]}`.toUpperCase();
    }
    return user.name.substring(0, 2).toUpperCase();
  };

  return (
    <nav className="top-navbar">
      <div className="d-flex align-items-center justify-content-between w-100">
        <div className="d-flex align-items-center">
          <button
            className="btn btn-link text-white p-0 me-3 toggle-btn"
            onClick={onToggleSidebar}
          >
            <i className="bi bi-list fs-3"></i>
          </button>
          <img
            src="/logo/Paynuts-logo-2026-white.png"
            alt="PayNuts"
            className="navbar-logo d-md-none"
          />
          <span className="navbar-title d-none d-md-inline">{title}</span>
        </div>

        {/* User Profile Dropdown */}
        <div className="user-profile-wrapper" ref={dropdownRef}>
          <div
            className="user-profile-trigger"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <div className="user-avatar">{getUserInitials()}</div>
            <span className="user-name d-none d-sm-inline">
              {user?.name || "User"}
            </span>
            <i
              className={`bi bi-chevron-down dropdown-arrow ${dropdownOpen ? "rotated" : ""}`}
            ></i>
          </div>

          {/* Dropdown Menu */}
          {dropdownOpen && (
            <div className="user-dropdown-menu">
              <div className="dropdown-item logout-item" onClick={handleLogout}>
                <i className="bi bi-box-arrow-right"></i>
                <span>Logout</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default TopNavbar;
